package org.teddapp.project.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

/**
 * Bloc d'encre : le seul élément sombre d'un écran, là où l'œil doit aller.
 * La recommandation d'Aujourd'hui, la prochaine micro-tâche, la course en cours.
 * Contenu libre ; [InkButton] et [InkGhostButton] donnent les deux boutons assortis.
 */
@Composable
fun TeddInkBlock(
    modifier: Modifier = Modifier,
    eyebrow: String? = null,
    title: String? = null,
    subtitle: String? = null,
    content: @Composable ColumnScope.() -> Unit = {},
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(TeddTokens.RLg))
            .background(TeddTokens.Ink, RoundedCornerShape(TeddTokens.RLg))
            .padding(TeddSpace.S5),
        verticalArrangement = Arrangement.spacedBy(TeddSpace.S2),
    ) {
        if (eyebrow != null) Text(eyebrow.uppercase(), style = TeddType.Overline, color = TeddTokens.Bg.copy(alpha = 0.62f))
        if (title != null) Text(title, style = TeddType.Title2, color = TeddTokens.Bg)
        if (subtitle != null) Text(subtitle, color = TeddTokens.Bg.copy(alpha = 0.72f), style = TeddType.Body)
        content()
    }
}

/** Bouton papier sur bloc d'encre : l'action primaire du bloc. */
@Composable
fun InkButton(text: String, onClick: () -> Unit, modifier: Modifier = Modifier, icon: (@Composable () -> Unit)? = null) {
    InkButtonBase(text, onClick, modifier, icon, TeddTokens.Bg, TeddTokens.Ink)
}

/** Bouton translucide sur bloc d'encre : l'action secondaire. */
@Composable
fun InkGhostButton(text: String, onClick: () -> Unit, modifier: Modifier = Modifier, icon: (@Composable () -> Unit)? = null) {
    InkButtonBase(text, onClick, modifier, icon, TeddTokens.Bg.copy(alpha = 0.12f), TeddTokens.Bg)
}

@Composable
private fun InkButtonBase(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier,
    icon: (@Composable () -> Unit)?,
    background: androidx.compose.ui.graphics.Color,
    foreground: androidx.compose.ui.graphics.Color,
) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(background, RoundedCornerShape(TeddTokens.RSm))
            .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null, onClick = onClick)
            .height(40.dp)
            .padding(horizontal = 14.dp),
        contentAlignment = Alignment.Center,
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
            icon?.invoke()
            Text(text, color = foreground, style = TeddType.Label.copy(fontSize = 14.sp), maxLines = 1)
        }
    }
}
